import { useIntersectionObserver } from '@react-hookz/web';
import { RefObject, useEffect } from 'react';

export const useInfiniteList = <T extends Element>(
  elementRef: RefObject<T> | T | null,
  rootRef: RefObject<T> | T | null,
  fetchMore: (intersection: IntersectionObserverEntry) => void,
) => {
  const intersection = useIntersectionObserver(elementRef, {
    root: rootRef,
    threshold: [0, 0.5],
  });

  useEffect(() => {
    if (intersection?.isIntersecting) {
      fetchMore(intersection);
    }
  }, [intersection, fetchMore]);
};
